var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from './Typography';
import Dropzone from 'react-dropzone';
import { IconButton } from './IconButton';
import { List, ListItem, Stack } from '@mui/material';
import { DeleteIcon, ImportIcon } from './Icons';
import { classImportDocument, getColors } from './Classes';
//import { bytesToSize } from '../../../../helper/byte'
var bytesToSize = function (size) { return ''; };
export var FileUpload = function (_a) {
    var files = _a.files, onDrop = _a.onDrop, onRemove = _a.onRemove, _b = _a.multiple, multiple = _b === void 0 ? false : _b, _c = _a.required, required = _c === void 0 ? false : _c;
    var palette = getColors();
    return (_jsx(Dropzone, __assign({ onDrop: onDrop, multiple: multiple }, { children: function (_a) {
            var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
            return (_jsxs("div", __assign({}, getRootProps(), { children: [_jsxs(Stack, __assign({ className: "mt-small", p: 5, style: classImportDocument(palette), alignItems: "center" }, { children: [_jsx("input", __assign({}, getInputProps())), _jsxs(Typography, { children: [_jsx(Typography, __assign({ startIcon: _jsx(ImportIcon, {}) }, { children: "Glissez-d\u00E9posez un fichier ou cliquez sur la zone" })), _jsx(Typography, { children: multiple
                                            ? 'Plusieurs fichiers autorisés'
                                            : 'Un seul fichier autorisé' })] })] })), files.length > 0 && (_jsx(List, { children: files.map(function (file, index) { return (_jsxs(ListItem, { children: ["".concat(file.name, " - ").concat(bytesToSize(file.size)), _jsx(IconButton, __assign({ tooltip: "Supprimer", onClick: function () { return onRemove(index); } }, { children: _jsx(DeleteIcon, {}) }))] }, index)); }) }))] })));
        } })));
};
//# sourceMappingURL=FileUpload.js.map